import {GTS_FAILURE, GTS_PENDING, GTS_SUCCESS} from './constants'

const initialState = {
  templateAudits: null,
  error: null,
  isLoading: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GTS_PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case GTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        ...action.payload,
      }
    case GTS_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }
    default:
      return state
  }
}

export default reducer
